import styled from 'styled-components';

export default styled.img`
    margin: auto;
    max-height: 100%;
    min-width: 100%;
`;
